import React from 'react';
import { TextField, MenuItem, Grid, Button } from '@mui/material';

const WorkExperience = ({ formData = { workExperience: [] }, setFormData }) => {
  const handleChange = (e, index) => {
    const newWorkExperience = [...formData.workExperience || []];
    newWorkExperience[index] = { ...newWorkExperience[index], [e.target.name]: e.target.value };
    setFormData({ ...formData, workExperience: newWorkExperience });
  };

  const addWorkExperience = () => {
    setFormData({
      ...formData,
      workExperience: [...formData.workExperience || [], {}]
    });
  };

  return (
    <Grid container spacing={2}>
      {(formData.workExperience || []).map((experience, index) => (
        <Grid item xs={12} key={index}>
          <TextField
            fullWidth
            label="Company Name"
            name="companyName"
            value={experience.companyName || ''}
            onChange={(e) => handleChange(e, index)}
          />
          <TextField
            fullWidth
            label="Designation"
            name="designation"
            value={experience.designation || ''}
            onChange={(e) => handleChange(e, index)}
          />
          <TextField
            fullWidth
            label="Start Date"
            type="date"
            name="startDate"
            value={experience.startDate || ''}
            onChange={(e) => handleChange(e, index)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label="End Date"
            type="date"
            name="endDate"
            value={experience.endDate || ''}
            onChange={(e) => handleChange(e, index)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label="Department"
            name="department"
            value={experience.department || ''}
            onChange={(e) => handleChange(e, index)}
            select
          >
            <MenuItem value="Controllership">Controllership</MenuItem>
            <MenuItem value="FP&A">FP&A</MenuItem>
            <MenuItem value="Audit">Audit</MenuItem>
            <MenuItem value="IT">IT</MenuItem>
            <MenuItem value="Tax">Tax</MenuItem>
            <MenuItem value="Treasury">Treasury</MenuItem>
            <MenuItem value="Risk">Risk</MenuItem>
            <MenuItem value="Compliance">Compliance</MenuItem>
          </TextField>
          <TextField
            fullWidth
            label="Key Responsibilities"
            name="keyResponsibilities"
            value={experience.keyResponsibilities || ''}
            onChange={(e) => handleChange(e, index)}
          />
          <TextField
            fullWidth
            label="Achievements & Notable Projects"
            name="achievementsNotableProjects"
            value={experience.achievementsNotableProjects || ''}
            onChange={(e) => handleChange(e, index)}
          />
          <TextField
            fullWidth
            label="Skills Used"
            name="skillsUsed"
            value={experience.skillsUsed || []}
            onChange={(e) => handleChange(e, index)}
            select
            SelectProps={{ multiple: true }}
          >
            <MenuItem value="Financial Reporting">Financial Reporting</MenuItem>
            <MenuItem value="Tax Compliance">Tax Compliance</MenuItem>
            <MenuItem value="Statutory Audit">Statutory Audit</MenuItem>
            <MenuItem value="Budgeting">Budgeting</MenuItem>
            <MenuItem value="Forecasting">Forecasting</MenuItem>
            <MenuItem value="Variance Analysis">Variance Analysis</MenuItem>
            <MenuItem value="Internal Audit">Internal Audit</MenuItem>
            <MenuItem value="Risk Assessment">Risk Assessment</MenuItem>
            <MenuItem value="External Audit">External Audit</MenuItem>
            <MenuItem value="GST">GST</MenuItem>
            <MenuItem value="Income Tax">Income Tax</MenuItem>
            <MenuItem value="Transfer Pricing">Transfer Pricing</MenuItem>
            <MenuItem value="Cash Flow Management">Cash Flow Management</MenuItem>
            <MenuItem value="Forex">Forex</MenuItem>
            <MenuItem value="Debt Management">Debt Management</MenuItem>
            <MenuItem value="ERP Implementation">ERP Implementation</MenuItem>
            <MenuItem value="Financial Modeling">Financial Modeling</MenuItem>
            <MenuItem value="SQL">SQL</MenuItem>
          </TextField>
        </Grid>
      ))}
      <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={addWorkExperience}>
          Add Work Experience
        </Button>
      </Grid>
    </Grid>
  );
};

export default WorkExperience;